// // 导入样式文件
import './Aivoices.less';
// // 导入React hooks
import { useEffect, useState } from 'react';
// // 导入自定义Icon组件
// import Icon from '@/components/iconfont/Icon.jsx';
import AiVoiceProvider from '@/providers/AiVoiceProvider.jsx';
import VoiceHeader from './components/voiceheader/VoiceHeader';
import VoiceList from './components/voicelist/VoiceList';
import PopUp from '../../components/popup/PopUp';
import { voiceController } from '@/api/index';
import { useDashboardData } from '@/hooks/DashboardHooks';
import { useTranslation } from 'react-i18next';
// 定义Assets组件
export default function Aivoices() {
  const { t } = useTranslation();
  const { userData, setChildCallback } = useDashboardData();
  const [voiceList, setVoiceList] = useState([]);
  const [loading, setLoading] = useState(false);
  // 控制通知显示状态
  const [showNotification, setShowNotification] = useState(false);
  // 控制创建类型模态框显示状态
  const [showCreateTypeModal, setShowCreateTypeModal] = useState(false);
  // 控制上传音频模态框显示状态
  const [showUploadAudioModal, setShowUploadAudioModal] = useState(false);
  // 控制录音模态框显示状态
  const [showRecordAudioModal, setShowRecordAudioModal] = useState(false);
  // 控制音频预览模态框显示状态
  const [showAudioPreviewModal, setShowAudioPreviewModal] = useState(false);
  // 控制修改名称模态框显示状态
  const [showChangeNameModal, setShowChangeNameModal] = useState(false);
  // 控制删除模态框显示状态
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  // 当前操作的item
  const [currentItem, setCurrentItem] = useState({});
  // 定义更新列表的时间戳
  const [updateTimestamp, setUpdateTimestamp] = useState(null);
  // 定义新增voices的名字
  const [newVoiceName, setNewVoiceName] = useState('');
  // 录音结束后得到的文件
  const [recordedFile, setRecordedFile] = useState(null);
  const [voiceDeleteTime, setVoiceDeleteTime] = useState(null);
  const [voiceLanguage, setVoiceLanguage] = useState(0);
  const providerValue = {
    // 通知显示状态
    showNotification,
    // 设置通知显示状态的函数
    setShowNotification,
    // 创建类型模态框显示状态
    showCreateTypeModal,
    // 设置创建类型模态框显示状态的函数
    setShowCreateTypeModal,
    // 上传音频模态框显示状态
    showUploadAudioModal,
    // 设置上传音频模态框显示状态的函数
    setShowUploadAudioModal,
    // 录音模态框显示状态
    showRecordAudioModal,
    // 设置录音模态框显示状态的函数
    setShowRecordAudioModal,
    // 音频预览模态框显示状态
    showAudioPreviewModal,
    // 设置音频预览模态框显示状态的函数
    setShowAudioPreviewModal,
    // 修改名称模态框显示状态
    showChangeNameModal,
    // 设置修改名称模态框显示状态的函数
    setShowChangeNameModal,
    // 删除模态框显示状态
    showDeleteModal,
    // 设置删除模态框显示状态的函数
    setShowDeleteModal,
    // 当前操作的项目
    currentItem,
    // 设置当前操作项目的函数
    setCurrentItem,
    // 设置更新时间戳的函数
    setUpdateTimestamp,
    // 新的语音名称
    newVoiceName,
    // 设置新的语音名称
    setNewVoiceName,
    // 录音结束后得到的文件
    recordedFile,
    // 设置录音结束后得到的文件
    setRecordedFile,
    userData,
    voiceDeleteTime,
    setVoiceDeleteTime,
    voiceLanguage,
    setVoiceLanguage,
  };
  // 关闭所有popup
  const CloseAllPupUp = (val) => {
    setShowNotification(false);
    setShowCreateTypeModal(false);
    setShowUploadAudioModal(false);
    setShowRecordAudioModal(false);
    setShowAudioPreviewModal(false);
    setShowChangeNameModal(false);
    setShowDeleteModal(false);
    if (val) {
      getlist();
    }
  };
  useEffect(() => {
    getlist();
  }, [updateTimestamp]);
  useEffect(() => {
    if (voiceDeleteTime > 0) {
      getlist();
      setChildCallback(Date.now());
    }
  }, [voiceDeleteTime]);
  useEffect(() => {
    if (showCreateTypeModal) {
      setNewVoiceName(userData?.userInfo?.username + `'s voice`);
    }
  }, [userData, showCreateTypeModal]);
  const getlist = async () => {
    setLoading(true);
    try {
      const res = await voiceController.assetsList();
      if (res.code === 0) {
        if (res.data.userVoices) {
          setVoiceList(res.data.userVoices);
          setChildCallback(Date.now());
        } else {
          setVoiceList([]);
        }
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const [pupUpTime, setPupUpTime] = useState(null);
  useEffect(() => {
    setPupUpTime(new Date().getTime());
  }, [
    showNotification,
    showCreateTypeModal,
    showUploadAudioModal,
    showRecordAudioModal,
    showAudioPreviewModal,
    showChangeNameModal,
    showDeleteModal,
  ]);
  return (
    <>
      {loading ? (
        <div className="loading_main">
          <span className="loading loading-spinner loading-md text-neutral"></span>
        </div>
      ) : (
        <div className="aivoice_box">
          <div className="aivoice_title">
            {/* AI Voices */}
            {t('As_Home_NavTitle3')}
          </div>
          <AiVoiceProvider
            value={{ voiceList, setVoiceList, ...providerValue, CloseAllPupUp, pupUpTime }}>
            <VoiceHeader />
            <VoiceList />
            <PopUp />
          </AiVoiceProvider>
        </div>
      )}
    </>
  );
}
